import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue'
import { EffectFade, Pagination } from 'swiper'

const AUTOPLAY_DELAY = 5000

export default /*#__PURE__*/_defineComponent({
  __name: 'Intro',
  setup(__props, { expose: __expose }) {
  __expose();

const modules = [EffectFade, Pagination]
const timeout = ref(null)

const goToNextSlide = (swiper) => {
  if (swiper.progress === 1) {
    swiper.slideTo(0)
  } else {
    swiper.slideNext()
  }
}

const onSlideChange = (swiper: any) => {
  const items = document.querySelectorAll('.js-main-slider-item')
  const videoItem = items[swiper.realIndex].querySelector('.js-video')
  const pagination = document.querySelector('.js-intro-pagination')
  const isMobile = window.innerWidth <= 768

  pagination.classList.remove('is-spaced')

  items.forEach(item => {
    const v = item.querySelector('.js-video')

    if (!v) return

    const videoUrl = v.getAttribute('data-video-url')
    const videoUrlMobile = v.getAttribute('data-video-url-mobile')
    const source = v.querySelector('source')

    if (isMobile && videoUrlMobile) {
      source.setAttribute('src', videoUrlMobile)
    } else {
      source.setAttribute('src', videoUrl)
    }

    v.pause()
    v.currentTime = 0
  })

  clearTimeout(timeout.value)

  if (videoItem) {
    let videoIsLoaded = false
    const videoUrlMobile = videoItem.getAttribute('data-video-url-mobile')

    if (isMobile && !videoUrlMobile) {
      pagination.classList.add('is-spaced')
    }

    const int = setInterval(async () => {
      try {
        await videoItem.play()

        videoItem.onended = () => {
          videoItem.pause()
          videoItem.currentTime = 0

          if (1 === items.length) {
            videoItem.play()
          } else {
            goToNextSlide(swiper)
          }
        }

        videoIsLoaded = true
      } catch (e) {
        videoIsLoaded = false
      }

      if (videoIsLoaded) {
        clearInterval(int)
      }
    }, 1000)
  } else {
    timeout.value = setTimeout(() => {
      goToNextSlide(swiper)
    }, AUTOPLAY_DELAY)
  }
}

const __returned__ = { AUTOPLAY_DELAY, modules, timeout, goToNextSlide, onSlideChange, ref, get EffectFade() { return EffectFade }, get Pagination() { return Pagination } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})